export default __webpack_public_path__ + "static/media/Tony Smehrik.b2e8cfcb.jpg";